import React, { useState } from 'react';
import prettySize from 'bytes';
import { ErrorMessage } from '@atlaskit/form';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import {
	FORM_DROPZONE_CONTAINER_ID,
	MINIMISED_DROPZONE_CONTAINER_ID,
} from '@atlassian/jira-issue-create-common-types/src/common/constants/index.tsx';
import CommonAttachmentsField from '@atlassian/jira-issue-create-commons/src/ui/attachments-field/index.tsx';
import { useMinimizableModal } from '@atlassian/jira-minimizable-modal/src/controllers/use-minimizable-modal/index.tsx';
import messages from './messages.tsx';
import type { AttachmentFieldProps } from './types.tsx';

export const useAttachmentValidationState = () => useState<boolean>(false);

const AttachmentsField = (props: AttachmentFieldProps) => {
	const { view } = useMinimizableModal();

	const {
		fieldId,
		fieldName,
		description,
		isRequired,
		additionalData,
		selectedProject,
		onInProgressChange,
		additionalData: { maxAllowedTotalAttachmentsSize },
		defaultValue,
		isCollapsed,
	} = props;

	const { mediaContext } = additionalData;
	const uploadToken = mediaContext?.uploadToken;
	const { formatMessage } = useIntl();
	const [attachmentSizeValidation, onAttachmentSizeValidation] = useAttachmentValidationState();

	let attachmentUploadContext;

	if (uploadToken) {
		attachmentUploadContext = {
			clientId: uploadToken.clientId,
			serviceHost: uploadToken.endpointUrl,
			collection: uploadToken.targetCollection,
			token: uploadToken.token,
		};
	}

	const dropzoneContainerId =
		view === 'modal' ? FORM_DROPZONE_CONTAINER_ID : MINIMISED_DROPZONE_CONTAINER_ID;

	return (
		<>
			<CommonAttachmentsField
				fieldId={fieldId}
				fieldName={fieldName}
				description={description}
				isRequired={isRequired}
				mediaUploadContext={attachmentUploadContext}
				projectId={selectedProject?.value || null}
				onInProgressChange={onInProgressChange}
				maxAllowedTotalAttachmentsSize={maxAllowedTotalAttachmentsSize}
				onAttachmentSizeValidation={onAttachmentSizeValidation}
				dropzoneContainerId={dropzoneContainerId}
				shouldScrollIntoViewOnUploadStart
				defaultValue={defaultValue}
				{...(fg('migrate_gic_smart_fields_jira_labs') && {
					isCollapsed,
				})}
			/>
			{!attachmentUploadContext && (
				<ErrorMessage>{formatMessage(messages.missingToken)}</ErrorMessage>
			)}
			{attachmentSizeValidation && (
				<ErrorMessage>
					{formatMessage(messages.attachmentSizeLimitCheck)} (
					{/* @ts-expect-error - TS2345 - Argument of type 'number | undefined' is not assignable to parameter of type 'number'. */}
					{prettySize(maxAllowedTotalAttachmentsSize, {
						unitSeparator: ' ',
					})}
					).
				</ErrorMessage>
			)}
		</>
	);
};

export default AttachmentsField;
